import { socialApiClient } from '@/shared/api-client/social-api-client';

export async function DeleteCampaign(campaignId: string, signal?: AbortSignal): Promise<void> {
  await socialApiClient.delete(`campaigns/${campaignId}`, {
    signal,
  });
}
